const env = process.env;

export const site = {
  name: "GOBAX",
  tagline: "TRÁFEGO & SITES",
  slogan: "Estratégia. Tecnologia. Crescimento.",
  whatsappNumber: env.REACT_APP_WHATSAPP_NUMBER || "",
  whatsappDisplay: env.REACT_APP_WHATSAPP_DISPLAY || "",
  whatsappNumberSites: env.REACT_APP_WHATSAPP_NUMBER_SITES || "",
  whatsappDisplaySites: env.REACT_APP_WHATSAPP_DISPLAY_SITES || "",
  instagramUrl: env.REACT_APP_INSTAGRAM_URL || "",
  email: env.REACT_APP_CONTACT_EMAIL || "",
  tracking: {
    gtmId: env.REACT_APP_GTM_ID || "",
    ga4Id: env.REACT_APP_GA4_ID || "",
    metaPixelId: env.REACT_APP_META_PIXEL_ID || "",
    googleAdsId: env.REACT_APP_GOOGLE_ADS_ID || "",
  },
};

export const WA_MESSAGES = {
  default:
    "Olá, GOBAX! Vim pelo site e quero impulsionar meu negócio com uma estratégia digital. Podemos conversar?",
  sites:
    "Olá, GOBAX! Vi o serviço de Criação de Sites no site de vocês e quero um site profissional para minha empresa. Podemos conversar?",
  trafego:
    "Olá, GOBAX! Vi o serviço de Tráfego Pago no site de vocês e quero anunciar com estratégia (Google Ads / Meta Ads). Podemos conversar?",
  rastreamento:
    "Olá, GOBAX! Vi o serviço de Rastreamento de Conversões no site de vocês e quero medir melhor meus resultados (GA4, GTM, Meta Pixel). Podemos conversar?",
  estrategia:
    "Olá, GOBAX! Vi o serviço de Estratégia e Crescimento Digital no site de vocês e quero uma estratégia para minha empresa. Podemos conversar?",
  local:
    "Olá, GOBAX! Tenho um negócio local e quero fortalecer minha presença digital para atrair mais clientes. Podemos conversar?",
  especialista:
    "Olá, GOBAX! Quero falar com um especialista sobre o próximo passo do meu negócio. Vim pela seção de contato do site.",
  site_que_vende:
    "Olá, GOBAX! Quero um site que vende. Vim pela página inicial e quero um orçamento para meu projeto.",
};

export const waLink = (message = WA_MESSAGES.default, number = site.whatsappNumber) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

export const waSitesLink = (message = WA_MESSAGES.sites) =>
  waLink(message, site.whatsappNumberSites || site.whatsappNumber);

export const scrollToId = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
};

export const NAV_LINKS = [
  { label: "Início", hash: "#inicio" },
  { label: "Soluções", hash: "#solucoes" },
  { label: "Como trabalhamos", hash: "#metodologia" },
  { label: "Resultados e métricas", hash: "#impacto" },
  { label: "Sobre", hash: "#sobre" },
  { label: "Contato", hash: "#contato" },
];
